import { logFindOnPageClicked, affordances } from "../../../util/analytics";
import { MATCH_NAV_DIRECTION } from "../utils/const";

const getDirectionAffordance = (direction) => {
  const directionAffordances = {
    [MATCH_NAV_DIRECTION.PREV]: affordances.PREVIOUS,
    [MATCH_NAV_DIRECTION.NEXT]: affordances.NEXT,
  };

  return directionAffordances[direction] || null;
};

export const useTelemetry = ({ inputValue, telemetryData }) => {
  const handleTelemetry = (direction) => {
    const affordance = getDirectionAffordance(direction);

    const { pageTitle: title, recordAn } = telemetryData ?? {};
    logFindOnPageClicked({
      title,
      recordAn,
      affordance,
      searchTerm: inputValue,
    });
  };

  return { handleTelemetry };
};
